<template>
  <div>
    <form @submit.prevent="handleSaleCompletion" id="sale-form">
      <div class="info-row">
        <span class="info-row-label">Customer:</span>
        <span class="info-row-value">{{
          `${student.firstName} ${student.lastName}`
        }}</span>
      </div>
      <div class="info-row">
        <span class="info-row-label">Billing Type:</span>
        <HiloSelect
          :options="billingTypes"
          required
          v-model="selectedBillingType"
        />
      </div>
      <div class="form-group center-button">
        <hilo-button
          label="Add Item"
          styleType="blue"
          @click="$emit('add-edit-item')"
        />
      </div>
      <div class="form-group">
        <hilo-table :columns="columns" :data="items" />
      </div>
      <div class="info-row">
        <span class="info-row-label">Total Sale:</span>
        <span class="info-row-value">{{ formatCurrency(total) }}</span>
      </div>
      <hilo-button type="submit" label="Submit" styleType="blue" modalButton />
    </form>
  </div>
</template>

<script>
import HiloButton from "@/components/HiloComponents/HiloButton.vue";
import HiloTable from "@/components/HiloComponents/HiloTable.vue";
import HiloSelect from "@/components/HiloComponents/HiloSelect.vue";
import BillingAPIService from "src/servicehandlers/BillingAPIService";
const billingAPIService = new BillingAPIService();
import dayjs from "dayjs";
import { formatCurrency } from "@/util/currency";

export default {
  components: { HiloTable, HiloButton, HiloSelect },
  props: {
    student: Object,
  },
  data() {
    return {
      items: [],
      billingTypes: [],
      billingStatuses: [],
      billingItemTypes: [],
      selectedBillingType: null,
      columns: [
        {
          key: "edit",
          label: "",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: "editIcon",
            onClick: () => this.editItem(row.id),
          }),
        },
        {
          key: "name",
          label: "Item",
          isHtml: true,
        },
        {
          key: "quantity",
          label: "Qty",
          format: (value) => parseFloat(value).toFixed(1),
        },
        {
          key: "price",
          label: "Price",
          format: (value) => this.formatCurrency(value),
        },
        {
          key: "total",
          label: "Total",
          format: (value) => this.formatCurrency(value),
        },
        {
          key: "remove",
          label: "",
          component: "HiloButton",
          componentProps: (row) => ({
            styleType: "redTrashIcon",
            onClick: () => this.removeItem(row.id),
          }),
        },
      ],
    };
  },
  computed: {
    total() {
      return this.items
        .reduce((sum, item) => sum + parseFloat(item.total), 0)
        .toFixed(2);
    },
  },
  async mounted() {
    await this.fetchMetaData();
  },
  methods: {
    formatCurrency,
    async fetchMetaData() {
      try {
        this.billingTypes = await billingAPIService.getBillingTypes();
        this.billingStatuses = await billingAPIService.getBillingStatuses();
        this.billingItemTypes = await billingAPIService.getBillingItemTypes();
      } catch (error) {}
    },
    getBillingTypeId(typeName) {
      const type = this.billingTypes.find((type) => type.name === typeName);
      return type ? type.id : null;
    },
    getBillingStatusId(statusName) {
      const status = this.billingStatuses.find(
        (status) => status.name === statusName,
      );
      return status ? status.id : null;
    },
    calculateTotal(price, quantity) {
      return (price * quantity).toFixed(2);
    },
    editItem(itemId) {
      const itemToEdit = this.items.find((item) => item.id === itemId);
      this.$emit("add-edit-item", itemToEdit);
    },
    removeItem(itemId) {
      this.items = this.items.filter((item) => item.id !== itemId);
    },
    handleSaveBillingItem(savedItem) {
      const index = this.items.findIndex((item) => item.id === savedItem.id);
      const recalculatedItem = {
        ...savedItem,
        total: this.calculateTotal(savedItem.price, savedItem.quantity),
      };

      if (index !== -1) {
        this.items.splice(index, 1, recalculatedItem);
      } else {
        this.items.push(recalculatedItem);
      }
    },
    async handleSaleCompletion() {
      //const billingTypeId = this.getBillingTypeId("Account");
      const billingStatusId = this.getBillingStatusId("Paid");

      const saleData = {
        date: dayjs(),
        activeStudentId: this.student.id,
        total: parseFloat(this.total),
        billingTypeId: this.selectedBillingType,
        billingStatusId,
        billingItems: this.items.map((item) => ({
          billingItemTypeId: item.billingItemTypeId,
          quantity: parseFloat(item.quantity),
          rate: parseFloat(item.price),
          aircraftId: item.aircraftId || null,
          activeInstructorId: item.activeInstructorId || null,
        })),
      };
      try {
        await billingAPIService.create(saleData);
      } catch (error) {}
    },
  },
};
</script>

<style scoped>
.info-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.info-row-label {
  font-weight: bold;
  margin-right: 10px;
}

.info-row-value {
  margin-right: 20px;
}

.form-group {
  margin-bottom: 20px;
}
.center-button {
  text-align: center;
}
</style>
